var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9997 1.83301C5.94884 1.83301 1.83301 5.94884 1.83301 10.9997C1.83301 16.0505 5.94884 20.1663 10.9997 20.1663C16.0505 20.1663 20.1663 16.0505 20.1663 10.9997C20.1663 5.94884 16.0505 1.83301 10.9997 1.83301ZM14.0797 13.108C14.3455 13.3738 14.3455 13.8138 14.0797 14.0797C13.9422 14.2172 13.768 14.2813 13.5938 14.2813C13.4197 14.2813 13.2455 14.2172 13.108 14.0797L10.9997 11.9713L8.89134 14.0797C8.75384 14.2172 8.57967 14.2813 8.40551 14.2813C8.23134 14.2813 8.05717 14.2172 7.91967 14.0797C7.65384 13.8138 7.65384 13.3738 7.91967 13.108L10.028 10.9997L7.91967 8.89134C7.65384 8.62551 7.65384 8.18551 7.91967 7.91967C8.18551 7.65384 8.62551 7.65384 8.89134 7.91967L10.9997 10.028L13.108 7.91967C13.3738 7.65384 13.8138 7.65384 14.0797 7.91967C14.3455 8.18551 14.3455 8.62551 14.0797 8.89134L11.9713 10.9997L14.0797 13.108Z",
    fill: "#EF4438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseStatus);
export default __webpack_public_path__ + "static/media/close-status.9939012b6c941298c31ea0bd72acb782.svg";
export { ForwardRef as ReactComponent };